<template>
  <div class="row" v-if="userData.permissions['print_invoice'] == 1">
    <div class="container-fluid">
      <div class="row">
        <div class="col-2">
          <span v-if="userData.logo != 0"
            ><img :src="getFiles(userData.logo)" height="100"
          /></span>
          <span v-else><img src="@/assets/images/logo.png" height="100"/></span>
        </div>
        <div class="col-7 mt-2">
          <h2
            style="color:black;font-weight: 700; "
            class="text-uppercase mb-1"
          >
            {{ userData.school }}
          </h2>
          <b style="color:black;font-size:12px"
            >Location: {{ userData.location }}</b
          ><br />
          <b style="color:black;font-size:12px"
            >Contacts: {{ userData.contact }}</b
          ><br />
          <b style="color:black;font-size:12px">E-mail: {{ userData.email }}</b
          ><br />
        </div>
        <div class="col-3 mt-3">
          <span
            style="color:black;font-size:13px;font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;"
          >
            Canteen: <br />
            <b style="font-size: 20px;"> {{ this.userData.canteen.name }}</b>
            <br />
            <i class="mdi mdi-phone"></i> {{ this.userData.canteen.telephone
            }}<br />
            Date : {{ this.$route.query.date }}</span
          >
        </div>
      </div>
      <hr style="border: 1px solid black;" />

      <center>
        <span
          style="color: black;font-family: tahoma;font-size:13px"
          class="text-decoration-underline text-uppercase"
          ><b> Canteen Invoice</b></span
        >
      </center>

      <div class="table-responsive">
        <b-table :items="Items" :fields="Fields" responsive="sm">
          <template #table-busy
            ><div class="text-center text-primary my-2">
              <b-spinner class="align-middle" type="grow" small></b-spinner>
              <strong>No Data Found</strong>
            </div></template
          >
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template #cell(students)="data">
            <b
              >{{ data.item.student.first_name }}
              {{ data.item.student.last_name }}<br /><small
                class="text-primary"
                >{{ data.item.student.student_id }}</small
              ></b
            >
            <br />{{ data.item.schoolclass[0].name }}
            {{ data.item.schoolstream[0].name }}
          </template>
          <template #cell(details)="data">
            <table class="table table-sm table-borderless mb-0">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Quantity</th>
                  <th>Price</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in data.item.details" :key="index">
                  <td>{{ item.name }}</td>
                  <td>{{ item.quantity }}</td>
                  <td>{{ commas(item.price) }}</td>
                  <td>{{ commas(item.quantity * item.price) }}</td>
                </tr>
                <tr class="table-active font-weight-bold">
                  <td colspan="3" class="text-end">Total:</td>
                  <td>
                    <b>{{ commas(calculateTotal(data.item.details)) }}</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
        </b-table>
      </div>
      <div class="text-center">
        <h4>
          Total Sales : <b class="text-primary">{{ commas(Total()) }} </b>
        </h4>
      </div>

      <div class="mt-3 text-center">
        <h5 style="color: black;" class="my-4 text-center">
          Signature : .........................
        </h5>
        <p style="color:black;font-size:13px">
          Printed by : {{ userData.username }} <br />
          Via School Dymanics Software | www.schooldynamics.cloud
        </p>

        <barcode
          :value="this.$route.query.date"
          height="50"
          display-value="false"
        ></barcode>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="row justify-content-center">
      <div class="col-md-8 col-xl-6">
        <div>
          <center>
            <span class="text-primary h4"
              >You have no permission to Print Canteen Invoices.</span
            >
          </center>
          <img
            src="@/assets/images/profile-img.png"
            alt
            class="img-fluid"
          /><br /><br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import VueBarcode from "vue-barcode";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Sales Invoices ",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { barcode: VueBarcode },
  data() {
    return {
      title: "Sales Invoices ",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Sales Invoices ", active: true },
      ],
      userData: JSON.parse(localStorage.getItem("user")),
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "students", label: "STUDENT", visible: true },
        { key: "details", label: "DETAILS", visible: true },
      ],
      id: "",
      student: "",
      item: "",
      name: "",
      selecteddate: new Date().toLocaleDateString("fr-CA"),
      sales: [],
    };
  },
  computed: {
    List() {
      return this.sales.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.sales;
    },
    IsBusy() {
      return this.sales.length === 0;
    },
  },

  mounted() {
    this.FetchData();
  },
  methods: {
    commas(x) {
      if (x == null || x == undefined) return "0";
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    calculateTotal(details) {
      return details.reduce((total, item) => {
        return total + item.quantity * item.price;
      }, 0);
    },
    Total() {
      return this.sales.reduce((total, sale) => {
        return total + this.calculateTotal(sale.details);
      }, 0);
    },
    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "logos/" + name;
      return imagelink;
    },
    async FetchData() {
      let formData = new FormData();
      formData.append("selecteddate", this.$route.query.date);
      let url = "/invoices";
      await axios.post(url, formData).then((response) => {
        this.sales = response.data.sales;
        setTimeout(() => {
          window.print();
          window.onafterprint = this.$router.go(-1);
        }, 1000);
      });
    },
  },
};
</script>
